export class AnswerRequest {
    public idParentQuestion: number;
    public answer: string;
    public idButtonType: number;
    public order: number;
    public idChildQuestion: number;
    public idCounseling: number;
    public idParent: number;
}